import {
  RESOURCE_TYPE_ATTR_TRANSFORM,
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_RECORD_TRANSFORM,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';

export const resourceName = (resourceType) => {
  const names = {
    [RESOURCE_TYPE_SOURCE]: 'SOURCE',
    [RESOURCE_TYPE_CREDENTIALS]: 'CREDENTIAL',
    [RESOURCE_TYPE_DATA_MAP]: 'LOOKUP',
    [RESOURCE_TYPE_ATTR_TRANSFORM]: 'TRANSFORM',
    [RESOURCE_TYPE_DATA_SET]: 'NEXSET',
    [RESOURCE_TYPE_SINK]: 'DESTINATION',
  };
  return names[resourceType] || '';
};

export const resourceNameTitled = (reference) => {
  const names = {
    [RESOURCE_TYPE_SOURCE]: 'Source',
    data_source: 'Source',
    [RESOURCE_TYPE_CREDENTIALS]: 'Credential',
    data_credential: 'Credential',
    [RESOURCE_TYPE_DATA_MAP]: 'Lookup',
    data_map: 'Lookup',
    [RESOURCE_TYPE_ATTR_TRANSFORM]: 'Transform',
    [RESOURCE_TYPE_DATA_SET]: 'Nexset',
    data_set: 'Nexset',
    [RESOURCE_TYPE_SINK]: 'Destination',
    data_sink: 'Destination',
  };
  if (typeof reference === 'string') {
    return names[reference] || '';
  } else {
    if (reference.type === RESOURCE_TYPE_ATTR_TRANSFORM) {
      if (reference.output_type === 'attribute') return 'Attribute Transform';
      if (reference.output_type === 'record') return 'Record Transform';
      if (reference.output_type === 'custom') return 'Connector Processor';
      return 'Transform';
    }
    return names[reference.type] || '';
  }
};
